export const articleLabels = {
    "en": {
        "buttonTitle": "See all articles",
        "subheadingButton": "Keep reading",
        "title": "View related articles"
    },
    "fr": {
        "buttonTitle": "Voir tous les articles",
        "subheadingButton": "Continuer à lire",
        "title": "Voir les articles connexes"
    },
    "es": {
        "buttonTitle": "Ver todos los artículos",
        "subheadingButton": "Sigue leyendo",
        "title": "Ver artículos relacionados"
    }

}